import { i18n } from '@/plugins/i18n'
import { subcategories } from '@/constants/subcategories'

export default [
    {
        field: 'id',
        title: '#',
        sortable: true,
        width: 70,
        type: 'number',
        selector: false,//{class: 'kt-checkbox--solid'},
        textAlign: 'center',
    },
    {
        field: 'image',
        title: i18n.t('label.image'),
        template: (row) => '<img src="'+row.image+'" width="60" />',
        sortable: false,
        textAlign:'center'
    },
    {
        field: 'title',
        title: i18n.t('label.title'),
        sortable: true,
    },
    {
        field: 'amount',
        title: i18n.t('label.amount'),
        sortable: true,
    },
]